import { VIEWING_METHODS } from '@/Hooks/PUJ/constants';
import {
  DateRange,
  Episode,
  LinearContent,
  LinearSlot,
  Maybe,
  ViewingMethod,
  VodViewingMethod,
} from '@skytvnz/sky-app-store/lib/types/graph-ql';
import dayjs from 'dayjs';

// eslint-disable-next-line import/prefer-default-export
export const isLiveSlotEndingSoon = (slot: LinearSlot | null): boolean => {
  if (slot?.start && slot?.end) {
    const now = dayjs();
    return now.isAfter(slot?.start) && now.isBefore(slot?.end) && now.diff(slot?.end, 'm') > -5;
  }
  return false;
};

export const isEpisodePromotedSlot = (episode?: Episode) =>
  episode?.__typename === 'Episode' &&
  // it should be handled as instant replay if there's any vod asset
  !episode.asset &&
  !!episode.promotedSlot;

export const getDateRange = (
  vodContent: Maybe<LinearContent> | undefined,
): DateRange | undefined => {
  return vodContent?.viewingMethods?.find((viewingMethod: Maybe<ViewingMethod>) => {
    const vodViewingMethod = viewingMethod as VodViewingMethod;
    return vodViewingMethod.__typename === VIEWING_METHODS.VOD;
  })?.dateRange;
};
